import useTranslation from 'next-translate/useTranslation'

import HeadingText from '../../../app/components/HeadingText'
import BodyText from '../../../app/components/BodyText'
import { CapacityConflictRowView } from '../../types'
import getVariantDisplayName from '../../../product/utils/getVariantDisplayName'

import styles from './CapacityConflictSummaryRow.module.scss'

type CapacityConflictSummaryRowProps = {
  row: CapacityConflictRowView
}

/**
 * A line the kitchen is trimming or dropping. Read-only - the kitchen's own
 * cart-order allocation decides what survives, so there is nothing left for
 * the guest to choose here.
 */
export default function CapacityConflictSummaryRow({
  row,
}: CapacityConflictSummaryRowProps) {
  const { t } = useTranslation('common')

  const { name, variantType, orderedQuantity, keptQuantity } = row

  const isTrimmed = keptQuantity > 0 && keptQuantity < orderedQuantity

  return (
    <div className={styles.row}>
      <HeadingText as="span" size="h3" className={styles.name}>
        {t('checkoutCapacityConflict.lineName', {
          quantity: orderedQuantity,
          name: getVariantDisplayName(name, variantType, t),
        })}
      </HeadingText>
      {isTrimmed && (
        <BodyText as="span" fontSize="1.2rem" color="body-2">
          {t('checkoutCapacityConflict.keepingQuantityOf', {
            keptQuantity,
            totalQuantity: orderedQuantity,
          })}
        </BodyText>
      )}
    </div>
  )
}
